module.exports = "/_next/static/images/noParking-ad596dc463b2c4784e3d769191492b22.png";